jQuery(document).ready(function($) {
    $('.copy-input.copy-by-data-attr').on('click', function(e) {
        e.stopPropagation();
    });
    $('.copy-input').on('click', function() {
        var $btn = $(this);

        // Jeśli element ma klasę .copy-by-data-attr – kopiujemy data-line1 i data-line2
        if ($btn.hasClass('copy-by-data-attr')) {
            var line1 = $btn.data('line1') || '';
            var line2 = $btn.data('line2') || '';
            var fullText = line1 + '\n' + line2;

            // Tymczasowe pole do kopiowania
            var $temp = $('<textarea>');
            $('body').append($temp);
            $temp.val(fullText).select();
            document.execCommand('copy');
            $temp.remove();

            showToast('Skopiowano wartość "' + fullText + '"');
        } else {
            // Standardowy tryb: kopiowanie wartości pola z kontenera
            var $container = $btn.closest('.has-meta-update, .edit-inline-select');
            var $field = $container.find('input, select, textarea').first();

            if ($field.length) {
                var value = $field.val();

                var $temp = $('<textarea>');
                $('body').append($temp);
                $temp.val(value).select();
                document.execCommand('copy');
                $temp.remove();
                showToast('Skopiowano wartość "' + value + '"');
            } else {
                console.warn('Nie znaleziono pola do skopiowania.');
            }
        }
    });

    function showToast(message) {
        var $toast = $('<div class="custom-toast"></div>').text(message);

        // Liczba już widocznych toastów
        var existingToasts = $('.custom-toast').length;

        // Ustawiamy pozycję top zależnie od ilości
        var offset = 20 + (existingToasts * 50); // 20px + 50px odstępu na każdy toast
        $toast.css('top', offset + 'px');

        $('body').append($toast);

        // Po 2 sekundy – znika
        setTimeout(function() {
            $toast.fadeOut(400, function() {
                $(this).remove();

                // Przesuwamy wszystkie pozostałe toast w górę
                $('.custom-toast').each(function(index) {
                    var newOffset = 20 + (index * 50);
                    $(this).css('top', newOffset + 'px');
                });
            });
        }, 2000);
    }

});
